import { render, staticRenderFns } from "./CardsWithSlogan.vue?vue&type=template&id=53f47e00"
import script from "./CardsWithSlogan.vue?vue&type=script&lang=js"
export * from "./CardsWithSlogan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports